<template>
  <div class="hm-proj-outr-wrp">
      <div class="content-box hm-proj-inner-wrp">
        <h1 class="hm-h1">We design & build world class websites, apps & softwares.</h1>
        <h2 class="hm-h2">Since 2012, we’ve designed, branded, and built phenomenal products and services for prominent companies.</h2>
        <div v-if="isTablet" class="car-wrp">
            <CarouselPlaceholder 
                v-if="!urls.length"
                :numberOfSlides="isDasktop ? 4 : 3"
            />
            <carousel
                v-else
                :slides="urls"
                :autoPlay="true"
                :slidesPerPage="isDasktop ? 4 : 3"
            >
                <template v-slot:slides="{computedSlides}">
                    <slide
                        v-for="(url,index) in computedSlides"
                        :key="index"
                    >
                        <a :href="url.link" target="_blank" class="proj-gal-wrp">
                            <div :href="url.link" target="_blank">
                                <div class="proj-gal-img" >
                                    <img width="303" height="471" v-image-load:fade :src="url.grid" :alt="url.name">
                                </div>
                            </div>
                            <div class="proj-gal-img-info-wrp">
                                <p class="proj-gal-img-name">{{url.name}}</p>
                                <p class="proj-gal-img-category">{{url.category}}</p>
                            </div>
                            <div class="proj-gal-visit">
                                <span>Visit Site</span>
                            </div>
                        </a>
                    </slide>
                </template>
                
                <template v-slot:arrowRight="{carousel}">
                    <div class="car-arrows">
                        <img @click="carousel.move(carousel.slideWidth)" src="../../assets/img/arrow-left.svg" class="car-arrow arrow-left">
                        <img @click="carousel.move(-carousel.slideWidth)" src="../../assets/img/arrow-right.svg" class="car-arrow arrow-right">
                    </div>
                </template>
            </carousel>
        </div>
        <gallary-list
            v-else-if="isMobile"
            :urls="urls"
        />
        <!-- <p class="proj-brands-txt">Brands we’ve helped advance into the digital world</p> -->
        <div class="proj-brands-bottom">
            <p class="proj-brands-txt">Brands we’ve helped advance in the digital world.</p>
            <div class="proj-brands-wrp">
                <div 
                    class="proj-brands-sing"
                    v-for="brand in brands"
                    :key="brand"    
                >
                    <img :src="require('../../assets/img/' + brand)" :alt="brand">
                </div>
            </div>
        </div>
      </div>
  </div>
</template>

<script>
import Carousel from '../carousel/Carousel'
import Slide from '../carousel/Slide'
import http from '../../api/requst'
import GallaryList from './GallaryList'
import CarouselPlaceholder from '../carousel/CarouselPlaceholder'
export default {
    data(){
        return{
            urls:[],
            brands:[
                `dynalink.svg`,
                `frenkel.svg`,
                `hello-lighting.png`,
                `newbridge.svg`,
                `telecom.svg`,
                `ucs.svg`,
            ],
            isDasktop:false,
            queryMediaDasktop:{},
            isMobile:false,
            queryMediaMobile:{},
            isTablet:false,
            queryMediaTablet:{},
        }
    },

    mounted(){
        this.queryMediaDasktop = window.matchMedia( '(max-width: 1366px)' )
		this.isDasktop = !this.queryMediaDasktop.matches
        this.queryMediaDasktop.addListener((e)=>{
            this.isDasktop = !e.matches
        })

        this.queryMediaMobile = window.matchMedia( '(min-width: 801px)' )
        this.isMobile = !this.queryMediaMobile.matches
        this.queryMediaMobile.addListener((e)=>{
            this.isMobile = !e.matches
        })

        this.queryMediaTablet = window.matchMedia( '(max-width: 800px)' )
        this.isTablet = !this.queryMediaTablet.matches
        this.queryMediaTablet.addListener((e)=>{
            this.isTablet = !e.matches
        })

        http('/projects').then(resp=>{
            this.urls = resp.data
            // setTimeout(()=>{
            //     for(let i = 0;i < 5; i++){
            //         this.urls.push(...resp.data)
            //     }
            // },2000)
            
        })
        .catch()
    },
  
    components: {
        Carousel,
        Slide,
        GallaryList,
        CarouselPlaceholder
    }
}
</script>

<style lang="scss" scoped>
.hm-proj-outr-wrp{
    background-color: #161717;
}

.hm-h1{
    font: {
        size: 66px;
        weight:600;
    }
    color: white;
    line-height: 81px;
    letter-spacing: -0.73px;
    padding-top: 10%;
}

.hm-h2{
    color:#818181 ;
    margin-top: 10px;
}

.car-wrp{
    padding-top: 50px;
}

.proj-gal-wrp{
    margin-right: 10px;
    margin-left: 10px;
    position: relative;
    display: block;
}

.proj-gal-img{
    max-height: 470px;
    height: 100%;
    overflow: hidden;
    background: transparent linear-gradient(0deg, #000000F7 0%, #5454544D 100%) 0% 0% no-repeat padding-box;
    border-radius: 10px;
    opacity: 0.63;
}

.proj-gal-img img{
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.proj-gal-img-info-wrp{
    color: white;
    position: absolute;
    background: transparent;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    bottom: 5%;
    width: 100%;
}

.proj-gal-img-name{
    font-size: 24px;
    // line-height: 78px;
    font-weight: 600;
}

.proj-gal-img-category{
    font-size: 15px;
    font-weight: 300;
}

.proj-gal-visit{
    width: 100%;
    display: flex;
    justify-content: center;
    bottom: 5%;
    transform: translateY(200%);
    transition: transform .2s ease;
    position: absolute;
}

.proj-gal-visit span{
    font-size: 24px;
    font-weight: 600;
    color: black;
    background: white;
    padding:14px 20%;
    text-align: center;
    border-radius: 37px;
}

.proj-gal-wrp:hover .proj-gal-visit{
    transform: translateY(0);
}

.car-arrows{
    display: flex;
    justify-content: center;
    margin-top: 30px;
    cursor: pointer;
}

.car-arrows img{
    margin-right: 15px;
    margin-left: 15px;
}

.proj-brands-txt{
    font-size: 17px;
    line-height: 49px;
    color:#818181;
    font-weight: 300;
}

.proj-brands-wrp{
    display: flex;
    justify-content: space-between;
    padding-top: 40px;
    padding-bottom: 70px;
    align-items: center;
}

.proj-brands-sing{
    height: 53px;
    width: 15%;
}

.proj-brands-sing img{
    height: 100%;
    width: 100%;
    object-fit: contain;
}

@media screen and (max-width: 1366px){
    .hm-h1{
        font-size: 50px;
        line-height: 59px;
    }

    .proj-gal-img-name{
        font-size: 17px;
    }

    .proj-gal-img-category{
        font-size: 11px;
    }

    .proj-gal-visit span{
        font-size: 18px;
    }

    .car-arrows{
        margin-top: 19px;
    }

    .proj-brands-wrp{
        padding-top: 22px;
        padding-bottom: 43px;
    }

    .proj-brands-sing{
        height: 34px;
    }

    .proj-brands-txt{
        font-size: 14px;
    }

}

@media screen and (max-width: 800px){
    .hm-h1{
        font-size: 48px;
        line-height: 57px;
    }
    .proj-brands-wrp{
        padding-top: 0;
        flex-wrap: wrap;
    }
    .proj-brands-bottom{
        padding-top: 43px;
    }
    .proj-brands-sing{
        height: 44px;
        width: 30.33%;
        margin-top: 37px;
        display: flex;
        justify-content: center;
    }
    .proj-brands-txt{
        font-size: 18px;
    }
}

@media screen and (max-width: 589px){
    .hm-h1{
        font-size: 28px;
        line-height: 38px;
    }
    .proj-brands-txt{
        font-size: 14px;
        line-height: 18px;
    }

    .proj-brands-sing{
        height: 34px;
    }
}

@media screen and (max-width: 320px){
    .proj-brands-sing{
        // height: 36px;
        width: 29.33%;
        margin-top: 20px;
    }
    .proj-brands-bottom{
        padding-top: 37px;
    }
    .proj-brands-wrp{
        padding-bottom: 37px;
    }
}
</style>